// extracted by mini-css-extract-plugin
module.exports = {"root":"About_root__a4NUR","collapsedText":"About_collapsedText__xnHHU","preText":"About_preText__pYF_E"};